import { useEffect, useState, useRef, useCallback } from "react";
import {
  User,
  Camera,
  Loader,
  EyeOff,
  Eye,
  Building2,
  AlertCircle,
  X,
  Check,
} from "lucide-react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchUserData,
  fetchUserActivities,
  fetchNotificationSettings,
  fetchAvailability,
  uploadProfileImage,
  logActivity,
  updateUserProfile,
  updateUserPassword,
  fetchCustomerProfile,
  fetchExpertProfile,
  cleanupProfileListeners,
  subscribeToUserProfile,
} from "../../store/profileSlice";
import {
  fetchUserTeamRole,
  setCurrentTeam,
} from "../../store/slices/teamSlice";
// Import Firestore functions
import {
  doc,
  updateDoc,
  collection,
  getDocs,
  getDoc,
} from "firebase/firestore";
import {
  fetchUserOrganizations,
  updateOrganization,
  subscribeToOrganization,
  cleanupOrgListeners,
} from "../../store/slices/orgSlice";
import csc from "countrycitystatejson";
import EditIcon from "../../assets/icons/edit.svg";
import Layout from "../../components/layout/layout";
import { Clock, Pencil, NotepadText } from "lucide-react";
import { useAppSelector } from "../../store/hooks";
import { useProfilesStore } from "../../hooks/useProfiles";
import { updateProfile } from "../../services/profileService";
import { AppDispatch, RootState } from "../../store";
import { useAppState } from "../../hooks/useAppState";
import { db } from "../../config/firebase";
import {
  getAuth,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { getStateFullName } from "../AddressControl/stateNameMapper";
import { getCountryFullName } from "../AddressControl/countryNameMapper";

type User = {
  id?: string;
  name?: string;
  email?: string;
  role?: "Customer" | "Expert" | "supporty_admin";
  password?: string;
  specialities?: string[];
  ratePerMinute?: string;
  bio?: string;
  rating?: number;
  availability?: boolean;
  profileImageUrl?: string;
  orgId?: string;
  uid?: string;
};

// Add type for organization form data
type OrganizationFormData = {
  organizationName: string;
  organizationURL: string;
  taxID: string;
  addressLine1: string;
  addressLine2: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
};

const specialtyOptions = [
  "Full-service implementations",
  "Account setup",
  "Project-oriented workflows",
  "Templates",
  "Reporting",
  "Admin",
  "Security",
  "Customisation",
  "Integrations & APIs",
  "New user onboarding",
  "Disaster recovery",
  "Dashboard setup",
  "Data migration",
  "Others (Specify)",
];

export function UserProfile() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const {} = useProfilesStore();
  // Redux selectors
  // const { user } = useAppState();
  const { user } = useAppState();
  const expertProfile = useAppSelector(
    (state: RootState) => state.profile.expertProfile
  );

  const customerProfile = useAppSelector(
    (state: RootState) => state.profile.customerProfile
  );
  const activities = useAppSelector(
    (state: RootState) => state.profile.activities
  );
  console.log(expertProfile, "expertProfile");
  console.log(user, "user in profile");
  const orgData = useAppSelector(
    (state: RootState) => state.organization.currentOrganization
  );
  console.log(customerProfile, "customerProfile in profile");
  console.log(orgData, "orgData in profile");
  // Remove direct assignment of currentTeam
  // const currentTeam = useAppSelector(
  //   (state: RootState) => state.team.currentTeam
  // );
  const [currentTeam] = useState(
    useAppSelector((state: RootState) => state.team.currentTeam)
  );

  const availability = useAppSelector(
    (state: RootState) => state.profile.availability
  );
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const [isLoadingActivities, setIsLoadingActivities] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState<User>({});
  console.log(formData, "formData in profile");
  const [uploadingImage, setUploadingImage] = useState(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<
    "Personal Profile" | "Team Profile"
  >("Personal Profile");
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPasswordChangeSection, setShowPasswordChangeSection] =
    useState(false);
  const [changePassConfirm, setChangePassConfirm] = useState(false);
  const [changePassLoading, setChangePassLoading] = useState(false);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
const[passwordChangeModel, setPasswordChangeModel] = useState(false);
const[passwordChangeSuccessModel, setPasswordChangeSuccessModel] = useState(false);
// Add state for new password and show/hide toggle
const [newPassword, setNewPassword] = useState("");
const [showNewPassword, setShowNewPassword] = useState(false);
const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (user?.role === "Expert" || user?.role === "expert_owner") {
      setActiveTab("Personal Profile");
      setFormData(expertProfile);
    } else {
      setFormData(customerProfile);
      setActiveTab("Personal Profile");
    }
  }, [customerProfile, expertProfile, user?.role]);

  // Add another effect to handle real-time profile updates
  useEffect(() => {
    if (
      expertProfile &&
      (user?.role === "Expert" || user?.role === "expert_owner")
    ) {
      console.log("Real-time expert profile update received:", expertProfile);
      setFormData(expertProfile);
    } else if (customerProfile && user?.role === "Customer") {
      console.log(
        "Real-time customer profile update received:",
        customerProfile
      );
      setFormData(customerProfile);
    }
  }, [expertProfile, customerProfile, user?.role]);
  console.log(formData, "formData in profile");
  console.log(user, "user in profile");
  // Addclg pagination states
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const lastActivityRef = useRef<HTMLDivElement | null>(null);

  const [editing, setEditing] = useState(false);
  const [teamName, setTeamName] = useState(orgData?.teamName);
  // Remove the hardcoded role state and rely on the Redux teamRole
  console.log(orgData, "orgData");
  // Add state for organization editing
  const [editingOrg, setEditingOrg] = useState(false);
  const [orgFormData, setOrgFormData] = useState<OrganizationFormData>({
    organizationName: orgData?.name || "",
    organizationURL: orgData?.url || "",
    taxID: orgData?.taxId || "",
    addressLine1: orgData?.billingAddress?.address_1 || "",
    addressLine2: orgData?.billingAddress?.address_2 || "",
    country: orgData?.billingAddress?.country || "",
    state: orgData?.billingAddress?.state || "",
    city: orgData?.billingAddress?.city || "",
    zipCode: orgData?.billingAddress?.postcode || "",
  });
  console.log(orgFormData, "orgFormData");
  const teamRole = user?.teamRole;
  // Updated team form data to use Redux state
  const [teamFormData, setTeamFormData] = useState({
    teamName: orgData?.teamName || "",
    role: teamRole || "",
  });
  const getInitialsImage = (name: string) => {
    if (!name) return null;
    const initials = name
      .split(" ")
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
    return (
      <div
        className="w-[100px] h-[100px] rounded-full flex items-center justify-center bg-gray-300 text-white font-bold text-3xl border border-gray-300"
        style={{ userSelect: "none" }}
      >
        {initials}
      </div>
    );
  };
  // Country and State management
  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  console.log(user, "user in profile "); // Debugging  // Add state for organization update
  const [isUpdatingOrg, setIsUpdatingOrg] = useState(false);
  const [isUpdatingTeam, setIsUpdatingTeam] = useState(false);
  const [orgUpdateError, setOrgUpdateError] = useState<string | null>(null);

  // Initialize countries on component mount
  useEffect(() => {
    try {
      const countryList = csc.getCountries();
      console.log("Country data structure:", countryList);
      // Ensure countryList is an array and has the expected structure
      if (Array.isArray(countryList)) {
        setCountries(countryList);
      } else {
        console.warn("Countries data is not in expected format:", countryList);
        setCountries([]);
      }
    } catch (error) {
      console.error("Error loading countries:", error);
      setCountries([]);
    }
  }, []);

  // Load states when editing organization and there's a country selected
  useEffect(() => {
    if (editingOrg && orgFormData.country) {
      try {
        const selectedCountry = csc.getCountryByShort(orgFormData.country);
        const statesData = selectedCountry?.states || {};

        let statesList: string[] = [];

        // Handle different data formats from the library
        if (Array.isArray(statesData)) {
          statesList = statesData;
        } else if (typeof statesData === "object" && statesData !== null) {
          statesList = Object.keys(statesData);
        } else {
          console.warn(
            "States data is neither array nor object for existing country:",
            statesData
          );
          statesList = [];
        }

        setStates(statesList);
      } catch (error) {
        console.error("Error loading states for existing country:", error);
        setStates([]);
      }
    }
  }, [editingOrg, orgFormData.country]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingUser(true);
        await dispatch(fetchUserData()).unwrap();
        await dispatch(fetchNotificationSettings()).unwrap();

        // Set up real-time profile subscriptions after user data is loaded
        if (user?.uid && user?.role) {
          console.log(
            "Setting up real-time profile subscription for:",
            user.uid,
            user.role
          );
          dispatch(subscribeToUserProfile(user?.uid, user?.role));
        }

        // Fetch teams if user and organization exist
        // if (user?.uid && user?.orgId) {
        //   await dispatch(
        //     fetchOrganizationTeams({
        //       orgId: user.orgId,
        //       userId: user.teamId,
        //     })
        //   ).unwrap();
        // }
      } finally {
        setIsLoadingUser(false);
      }
    };

    fetchData();

    // Cleanup function to remove listeners when component unmounts
    return () => {
      if (user?.uid) {
        dispatch(cleanupProfileListeners(user.uid));
      }
    };
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setFormData(user); // Only set when user is non-null

      // Fetch profile data based on user role
      if (user.role === "Expert" || user.role === "expert_owner") {
        dispatch(fetchExpertProfile(user.uid));
      } else if (user.role === "Customer") {
        dispatch(fetchCustomerProfile(user.uid));
      }
    }

    const fetchActivities = async () => {
      try {
        setIsLoadingActivities(true);
        await dispatch(fetchUserActivities(1)).unwrap();
        setPage(1);
        setHasMore(true);
      } finally {
        setIsLoadingActivities(false);
      }
    };

    fetchActivities();
  }, [user, dispatch]);

  // Add intersection observer for infinite scroll
  const loadMoreActivities = useCallback(async () => {
    if (!loadingMore && hasMore) {
      try {
        setLoadingMore(true);
        const nextPage = page + 1;
        // Modify this to match your actual function for fetching more activities
        // This assumes fetchUserActivities can accept a page parameter
        const newActivities = await dispatch(
          fetchUserActivities(nextPage)
        ).unwrap();
        if (newActivities && newActivities.length > 0) {
          setPage(nextPage);
        } else {
          setHasMore(false);
        }
      } catch (error) {
        console.error("Failed to load more activities:", error);
      } finally {
        setLoadingMore(false);
      }
    }
  }, [page, loadingMore, hasMore, dispatch]);

  // Setup intersection observer
  useEffect(() => {
    if (isLoadingActivities) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          loadMoreActivities();
        }
      },
      { threshold: 0.1 }
    );

    observerRef.current = observer;

    const currentRef = lastActivityRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isLoadingActivities, hasMore, loadMoreActivities, activities]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Add state for custom specialty input
  const [showCustomSpecialty, setShowCustomSpecialty] = useState(false);
  const [customSpecialty, setCustomSpecialty] = useState("");
  const [customSpecialties, setCustomSpecialties] = useState<string[]>([]);
  const [customSpecialtyError, setCustomSpecialtyError] = useState<string>("");

  // Effect to initialize customSpecialties from formData when user data is loaded
  useEffect(() => {
    if (formData?.specialities && Array.isArray(formData?.specialities)) {
      // Filter out predefined specialties to get only custom ones
      const userCustomSpecialties = formData?.specialities.filter(
        (specialty) => !specialtyOptions.includes(specialty)
      );
      setCustomSpecialties(userCustomSpecialties);
    }
  }, [formData?.specialities]);

  // Add function to handle custom specialty
  const handleAddCustomSpecialty = () => {
    if (customSpecialty.trim()) {
      const newCustom = customSpecialty.trim();

      // Add to form data specialities
      setFormData((prev) => {
        const updatedSpecialties = prev.specialities || [];
        if (!updatedSpecialties.includes(newCustom)) {
          return {
            ...prev,
            specialities: [...updatedSpecialties, newCustom],
          };
        }
        return prev;
      });
      // Add to custom specialties list for display
      setCustomSpecialties((prev) => [...prev, newCustom]);

      // Reset input
      setCustomSpecialty("");
    }
  };

  // Function to remove a custom specialty
  const removeCustomSpecialty = (specialty: string) => {
    setFormData((prev) => {
      const updatedSpecialties =
        prev.specialities?.filter((s) => s !== specialty) || [];
      return {
        ...prev,
        specialities: updatedSpecialties,
      };
    });

    setCustomSpecialties((prev) => prev.filter((s) => s !== specialty));
  };

  // Modify the specialty change handler to handle "Others (Specify)"
  const handleSpecialtyChange = (specialty: string) => {
    if (specialty === "Others (Specify)") {
      setShowCustomSpecialty(!showCustomSpecialty);
      return;
    }

    // Check if it's a predefined specialty or a custom one
    const isCustom = !specialtyOptions.includes(specialty);

    setFormData((prev) => {
      const updatedSpecialties = prev.specialities || [];
      if (updatedSpecialties.includes(specialty)) {
        // Remove the specialty
        const newSpecialties = updatedSpecialties.filter(
          (s) => s !== specialty
        );

        // If removing a custom specialty, also update the customSpecialties state
        if (isCustom) {
          setCustomSpecialties(
            customSpecialties.filter((s) => s !== specialty)
          );
        }

        return {
          ...prev,
          specialities: newSpecialties,
        };
      } else {
        // Add the specialty
        return {
          ...prev,
          specialities: [...updatedSpecialties, specialty],
        };
      }
    });
  };



  const saveChanges = async () => {
    setIsLoadingSave(true);
    setCustomSpecialtyError("");
    try {
      if (!user) return;
      // Validation: If Others (Specify) is checked, input must not be empty
      if (
        showCustomSpecialty &&
        editMode &&
        !customSpecialty.trim() &&
        !customSpecialties.length
      ) {
        setCustomSpecialtyError(
          "Please enter your specialty in the 'Others (Specify)' field."
        );
        setIsLoadingSave(false);
        return;
      }
      // Ensure custom specialty is added to specialities before saving
      let updatedFormData = { ...formData };
      if (customSpecialty.trim()) {
        const newCustom = customSpecialty.trim();
        const updatedSpecialties = updatedFormData.specialities || [];
        if (!updatedSpecialties.includes(newCustom)) {
          updatedFormData.specialities = [...updatedSpecialties, newCustom];
        }
        setCustomSpecialties((prev) => [...prev, newCustom]);
        setCustomSpecialty("");
      }
      // const result = await updateProfile(user.id, updatedFormData as any);
      await dispatch(updateUserProfile(updatedFormData)).unwrap();
      // Log activity
      if (user?.uid) {
        dispatch(
          logActivity({
            userId: user.uid,
            type: "profile_update",
            metadata: { details: "Profile Updated" },
          })
        );
      }
      setEditMode(false);
      setIsLoadingSave(false);
    } catch (error) {
      console.error("Failed to update profile:", error);
      setIsLoadingSave(false);
    }
  };
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files) return;

    const file = event.target.files[0];
    try {
      setUploadingImage(true);
      await dispatch(uploadProfileImage(file)).unwrap();
    } catch (error) {
      alert("Failed to upload image. Please try again.");
    } finally {
      setUploadingImage(false);
    }
  };
  // Handler for modal confirm
const handleConfirm = async () => {
  setErrorMessage("");
  // Basic validation
  if (!currentPassword || !newPassword) {
    setErrorMessage("Please enter both current and new password.");
    return;
  }
  // Password strength validation (example, can be improved)
  const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;
  if (!strongRegex.test(newPassword)) {
    setErrorMessage(
      "Password must be at least 8 characters, include uppercase, lowercase, a number, and a special character."
    );
    return;
  }
  setIsLoadingPassword(true);
  try {
    // Firebase re-authentication
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser || !user?.email) {
      setErrorMessage("User not authenticated.");
      setIsLoadingPassword(false);
      return;
    }
    const credential = EmailAuthProvider.credential(user?.email, currentPassword);
    await reauthenticateWithCredential(currentUser, credential);

    await dispatch(
      updateUserPassword({
        newPassword: newPassword,
        currentPassword: currentPassword,
      })
    ).unwrap();

    setFormData((prev) => ({ ...prev, password: "" }));
    setCurrentPassword("");
    setNewPassword("");
    setPasswordChangeModel(false);
    setPasswordChangeSuccessModel(true);
  } catch (error: any) {
    setErrorMessage("Current password is incorrect or update failed.");
  } finally {
    setIsLoadingPassword(false);
  }
};

// Handler for modal cancel
const handleCancel = () => {
  setPasswordChangeModel(false);
  setCurrentPassword("");
  setNewPassword("");
  setShowCurrentPassword(false);
  setShowNewPassword(false);
  setErrorMessage("");
};

  // Add handle change for organization form
  const handleOrgChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Handle country change - update states accordingly
    if (name === "country") {
      try {
        const selectedCountry = csc.getCountryByShort(value);
        console.log("Selected country data:", selectedCountry);
        const statesData = selectedCountry?.states || {};
        console.log("States data before processing:", statesData);

        let statesList: string[] = [];

        // Handle different data formats from the library
        if (Array.isArray(statesData)) {
          // If it's already an array, use it as is
          console.log("States is an array:", statesData);
          statesList = statesData;
        } else if (typeof statesData === "object" && statesData !== null) {
          // If it's an object, extract the keys as state names
          statesList = Object.keys(statesData);
          console.log("Converted object keys to array:", statesList);
        } else {
          // Fallback to empty array
          console.warn("States data is neither array nor object:", statesData);
          statesList = [];
        }

        console.log("Final states array:", statesList);
        setStates(statesList);

        setOrgFormData((prev) => ({
          ...prev,
          [name]: value,
          state: "", // Reset state when country changes
        }));
      } catch (error) {
        console.error("Error getting states for country:", error);
        setStates([]);
        setOrgFormData((prev) => ({
          ...prev,
          [name]: value,
          state: "",
        }));
      }
    } else {
      setOrgFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  
  console.log(user, "user in handleOrgSubmit"); // Updated handleOrgSubmit function
  const handleOrgSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Get organization ID from either orgData.id or user.orgId
    const organizationId = user?.orgId;

    if (!organizationId) {
      setOrgUpdateError("Organization ID not found");
      return;
    }

    setIsUpdatingOrg(true);
    setOrgUpdateError(null);
    try {
      // Validate required fields
      // Map form data to the structure expected by the updateOrganization action
      const updateData = {
        name: orgFormData.organizationName || "",
        url: orgFormData.organizationURL || "",
        taxId: orgFormData.taxID || "", // Always include taxId
        billingAddress: {
          address_1: orgFormData.addressLine1 || "",
          address_2: orgFormData.addressLine2 || "",
          country: orgFormData.country || "",
          state: orgFormData.state || "",
          city: orgFormData.city || "",
          postcode: orgFormData.zipCode || "",
        },
      };

      // Check if the organization document exists first
      const orgRef = doc(db, `organizations/${organizationId}`);
      const orgDoc = await getDoc(orgRef);

      if (!orgDoc.exists()) {
        throw new Error(`Organization document not found: ${organizationId}`);
      }

      // Dispatch the action to update the organization
      await dispatch(
        updateOrganization({
          orgId: organizationId,
          orgData: updateData,
        })
      ).unwrap();

      // After update, immediately sync orgFormData with latest orgData from Redux
      if (orgData) {
        setOrgFormData({
          organizationName: orgData.name || "",
          organizationURL: orgData.url || "",
          taxID: orgData.taxId || "",
          addressLine1: orgData.billingAddress?.address_1 || "",
          addressLine2: orgData.billingAddress?.address_2 || "",
          country: orgData.billingAddress?.country || "",
          state: orgData.billingAddress?.state || "",
          city: orgData.billingAddress?.city || "",
          zipCode: orgData.billingAddress?.postcode || "",
        });
      }

      // Log the activity - use either user.id or user.uid
      const userId =  user?.uid;
      if (userId) {
        dispatch(
          logActivity({
            userId: userId,
            type: "organization_update",
            metadata: { details: "Organization details updated" },
          })
        );
      }

      // Close edit mode
      setEditingOrg(false);

      // Fetch updated organization data
      if (user?.uid && user?.orgId) {
        console.log("Fetching organization with:", {
          uid: user.uid,
          orgId: user.orgId,
        });
        dispatch(
          fetchUserOrganizations({ uid: user.uid, orgId: user.orgId }) as any
        );
      }
    } catch (error: any) {
      console.error("Failed to update organization:", error);
      setOrgUpdateError(error.message || "Failed to update organization");
    } finally {
      setIsUpdatingOrg(false);
    }
  };
  useEffect(() => {
    // Initial fetch of organization data
    dispatch(
      fetchUserOrganizations({ uid: user?.uid, orgId: user?.orgId }) as any
    );

    // Set up real-time subscription if orgId exists
    if (user?.orgId) {
      dispatch(
        subscribeToOrganization({
          orgId: user.orgId,
          listenerId: `profile-${user.uid}`,
        })
      );
    }

    // Clean up subscription when component unmounts
    return () => {
      if (user?.orgId) {
        cleanupOrgListeners(`profile-${user.uid}`);
      }
    };
  }, [user?.uid, user?.orgId, dispatch]);

  console.log(user, "user in profile after org update"); // Debugging
  // Add handler for team form changes
  const handleTeamFormChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setTeamFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // Update team form data when current team or teamRole changes
  useEffect(() => {
    if (orgData) {
      setTeamFormData({
        teamName: orgData?.teamName,
        role: teamRole || "Team Member",
      });
      setTeamName(orgData?.teamName);

      // Fetch user's role in the team
      if (user?.uid && user?.orgId && currentTeam?.teamId) {
        dispatch(
          fetchUserTeamRole({
            orgId: user.orgId,
            teamId: currentTeam?.teamId,
            userId: user.uid,
          })
        );
      }
    }
  }, [currentTeam, teamRole, user?.uid, user?.orgId, dispatch]); // Add handler for team form submission
  console.log("currentTeam", currentTeam);
  const handleTeamFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsUpdatingTeam(true);
    try {
      // Close the editing mode

      // If we have a current team and organization ID, update the team name in Firestore
      if (currentTeam && user?.orgId) {
        const updatedTeam = {
          ...currentTeam,
          teamName: teamFormData.teamName,
        };

        // Update team in Redux store
        dispatch(setCurrentTeam(updatedTeam));

        // Update team name in Firestore using the correct collection path
        const teamDocRef = doc(
          db,
          `organizations/${user?.orgId}/teams`,
          currentTeam.id
        );
        await updateDoc(teamDocRef, { teamName: teamFormData.teamName });

        // Update teamName in the organization document as well
        const orgDocRef = doc(db, `organizations/${user?.orgId}`);
        await updateDoc(orgDocRef, { teamName: teamFormData.teamName });

        console.log(
          "Team name updated successfully in Firestore and organization doc"
        );

        // Log activity if user ID is available
        if (user?.uid) {
          dispatch(
            logActivity({
              userId: user.uid,
              type: "team_update",
              metadata: { details: "Team name updated" },
            })
          );
        }
      } else {
        console.error("Missing organization ID or team ID for update");
      }
    } catch (error) {
      console.error("Error updating team name:", error);
      // Optional: You could set an error state here to display to the user
    } finally {
      setEditing(false);
      setIsUpdatingTeam(false);
    }
  };

  // Add handler for navigating to team details
  const handleViewTeamDetails = () => {
    if (user?.role === "Expert" || user?.role === "expert_owner") {
      navigate("/expert/teams");
    } else if (user?.role === "Customer" || user?.role === "customer_owner") {
      navigate("/user/teams");
    }
  };

  // Add effect to sync orgFormData with orgData (Redux currentOrganization)
  useEffect(() => {
    if (orgData) {
      setOrgFormData({
        organizationName: orgData.name || "",
        organizationURL: orgData.url || "",
        taxID: orgData.taxId || "",
        addressLine1: orgData.billingAddress?.address_1 || "",
        addressLine2: orgData.billingAddress?.address_2 || "",
        country: orgData.billingAddress?.country || "",
        state: orgData.billingAddress?.state || "",
        city: orgData.billingAddress?.city || "",
        zipCode: orgData.billingAddress?.postcode || "",
      });
    }
  }, [orgData]);

  // Merge specialtyOptions (excluding "Others (Specify)") and customSpecialties for rendering
  const mergedSpecialties = [
    ...specialtyOptions.filter((s) => s !== "Others (Specify)"),
    ...customSpecialties,
  ];

  return (
    <Layout>
      <div className=" p-4"  style={{
          height: "calc(100vh - 112px)",
          overflowY: "auto",
            overflowX:'hidden'
        }}>
        <div className="space-y-6">
          {/* Profile Section */}
          <div className="flex">
            <button
              className={`py-2 px-8 text-[16px] nunito-semibold ${
                activeTab === "Personal Profile"
                  ? "border-b-4 border-[#F15D18] text-[#F15D18]"
                  : "text-[#A8A8A8]"
              }`}
              onClick={() => setActiveTab("Personal Profile")}
            >
              Personal Profile
            </button>
            {user?.role !== "supporty_admin" && (
              <button
                className={`py-2 px-8 text-[16px] nunito-semibold  ${
                  activeTab === "Team Profile"
                    ? "border-b-4 border-[#F15D18] text-[#F15D18]"
                    : "text-[#A8A8A8]"
                }`}
                onClick={() => setActiveTab("Team Profile")}
              >
                {user?.role === "Expert" || user?.role === "expert_owner"
                  ? "Organization Profile"
                  : "Organization Profile"}
              </button>
            )}
          </div>

          {activeTab === "Personal Profile" ? (
            <>
              <div className="bg-white rounded-lg shadow p-6 relative">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center">
                    <h2 className="text-[20px] text-[#696969] nunito-semibold">
                      Profile Information
                    </h2>
                  </div>

                  {/* Buttons */}
                  <div>
                    {!editMode ? (
                      <button
                        onClick={() => setEditMode(true)}
                        className="px-4 py-2 "
                      >
                        <img
                          src={EditIcon}
                          alt="No Data"
                          className="h-[32px] w-[32px]"
                        />
                      </button>
                    ) : (
                      <div className="flex space-x-4">
                        <button
                          onClick={saveChanges}
                          disabled={isLoadingSave}
                          className="flex justify-center items-center px-4 py-2 w-[160px] h-[48px] text-[16px] nunito-bold bg-[#F15D18] text-white rounded-[8px] hover:bg-[#F15D18]"
                        >
                          {isLoadingSave ? (
                            <Loader
                              className="animate-spin text-[#FFFFFF]"
                              size={24}
                            />
                          ) : (
                            "Save Changes"
                          )}
                        </button>
                        <button
                          onClick={() => {
                            setEditMode(false);
                            // setFormData(user); // Revert changes
                          }}
                          className="px-4 py-2 w-[151px] h-[48px] bg-none text-[#F15D18] text-[16px] nunito-semibold rounded-[8px] hover:bg-none border border-[#F15D18]"
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Form Fields */}
                {isLoadingUser ? (
                  // <p className="text-gray-500">Loading profile data...</p>
                  <div className="flex justify-center">
                    <Loader className="animate-spin text-[#F15D18]" size={24} />
                  </div>
                ) : (
                  <div className="space-y-6">
                    {editMode ? (
                      /* Edit Mode Layout */
                      <div className="flex items-center gap-8">
                        {/* Profile Image - Centered across all rows */}
                        <div className="flex flex-col items-center justify-center">
                          <div className="relative w-[100px] h-[100px]">
                            {formData?.profileImageUrl ? (
                            <img
                              src={formData?.profileImageUrl}
                              alt="Profile"
                              className="w-[100px] h-[100px] rounded-full object-cover border border-gray-300"
                            />
                          ) : (
                            getInitialsImage(formData?.name || "")
                          )}
                            <label className="absolute bottom-0 right-0 bg-indigo-600 p-2 rounded-full disabled:cursor-not-allowed cursor-pointer">
                              <Camera className="h-4 w-4 text-white" />
                              <input
                                type="file"
                                className="hidden"
                                accept="image/*"
                                onChange={handleImageUpload}
                                disabled={uploadingImage}
                                
                              />
                            </label>
                            {uploadingImage && (
                              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full">
                                <Loader
                                  className="animate-spin text-white"
                                  size={24}
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Form Fields Container */}
                        <div className="flex-1 space-y-6">
                          {/* First Row: Full Name and Email */}
                          <div className="flex gap-6">
                            <div className="flex flex-col">
                              <label className="block text-[16px] nunito-regular  text-[#404040] mb-2">
                                Full Name
                              </label>
                              <input
                                type="text"
                                name="name"
                                value={formData?.name || ""}
                                onChange={handleChange}
                                disabled={isLoadingSave}
                                className="w-[320px] h-[54px] px-4 py-3 rounded-[6px] text-[#696969] text-[18px] nunito-regular outline-none border-[1px] border-[#696969]"
                              />
                            </div>
                            <div className="flex flex-col">
                              <label className="block text-[16px] nunito-regular text-[#404040] mb-2">
                                Email
                              </label>
                              <input
                                type="email"
                                name="email"
                                value={formData?.email || ""}
                                onChange={handleChange}
                                disabled={isLoadingSave}
                                className="w-[320px] h-[54px] px-4 py-3 rounded-[6px] text-[#696969] text-[18px] nunito-regular outline-none border-[1px] border-[#696969]"
                              />
                            </div>
                          </div>

                          {/* Second Row: Current Password and Change Password Button */}
                          <div className="flex gap-6 items-end">
                          

                            <button
                              onClick={() => {
                              
                                 setPasswordChangeModel(true);
                              
                              }}
                             
                              className={`px-4 py-2 w-[180px] h-[54px] nunito-semibold rounded-[6px] ${passwordChangeModel ? " bg-[#C4C4C4] text-[#FFFFFF]":" bg-[#F15D18] text-white text-[16px] "}`}
                            >
                              
                                Change Password
                            
                            </button>
                          </div>

                        
                        </div>
                      </div>
                    ) : (
                      /* View Mode Layout */
                      <div className="flex items-start gap-6">
                        <div className="relative w-[100px] h-[100px]">
                          {formData?.profileImageUrl ? (
                            <img
                              src={formData?.profileImageUrl}
                              alt="Profile"
                              className="w-[100px] h-[100px] rounded-full object-cover border border-gray-300"
                            />
                          ) : (
                            getInitialsImage(formData?.name || "")
                          )}
                        </div>
                        <div className="flex flex-col">
                          <h3 className="text-[18px] nunito-semibold text-[#696969] mb-2">
                            {formData?.name}
                          </h3>
                          <p className="text-[18px] nunito-medium text-[#696969] mb-2">
                            Email: {formData?.email}
                          </p>
                          <p className="text-[18px] nunito-medium text-[#696969]">
                            Password: xxxxxxxxxx
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Expert-Specific Fields */}
                    {user?.role === "Expert" && (
                      <>
                        <div className="col-span-2">
                          <label className="text-[20px] text-[#696969] nunito-semibold">
                            {" "}
                            Areas of Expertise
                          </label>
                          <div className="grid grid-cols-2 gap-2">
                            {mergedSpecialties.map((specialty) => (
                              <label
                                key={specialty}
                                className="flex items-center space-x-2 cursor-pointer group"
                              >
                                <div className="relative">
                                  <input
                                    type="checkbox"
                                    checked={
                                      Array.isArray(formData?.specialities) &&
                                      formData?.specialities.includes(specialty)
                                    }
                                    onChange={() =>
                                      handleSpecialtyChange(specialty)
                                    }
                                    className="absolute w-0 h-0 opacity-0"
                                    disabled={!editMode || isLoadingSave}
                                  />
                                  <div
                                    className={`w-[16px] h-[16px] border rounded transition-all duration-200 flex items-center justify-center ${
                                      Array.isArray(formData?.specialities) &&
                                      formData?.specialities.includes(specialty)
                                        ? "bg-[#F15D18] border-[#F15D18]"
                                        : "border-gray-300 bg-white"
                                    } ${
                                      editMode
                                        ? "group-hover:border-[#F15D18]"
                                        : ""
                                    }`}
                                  >
                                    {Array.isArray(formData?.specialities) &&
                                      formData?.specialities.includes(
                                        specialty
                                      ) && (
                                        <svg
                                          className="w-3 h-3 text-white animate-scale-in"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="3"
                                            d="M5 13l4 4L19 7"
                                          ></path>
                                        </svg>
                                      )}
                                  </div>
                                </div>
                                <span className="text-[14px] nunito-semibold text-[#6D7483]">
                                  {specialty}
                                </span>
                              </label>
                            ))}
                            {/* Render Others (Specify) checkbox */}
                            <label
                              key="Others (Specify)"
                              className="flex items-center space-x-2 cursor-pointer group"
                            >
                              <div className="relative">
                                <input
                                  type="checkbox"
                                  checked={showCustomSpecialty}
                                  onChange={() =>
                                    setShowCustomSpecialty(!showCustomSpecialty)
                                  }
                                  className="absolute w-0 h-0 opacity-0"
                                  disabled={!editMode || isLoadingSave}
                                />
                                <div
                                  className={`w-[16px] h-[16px] border rounded transition-all duration-200 flex items-center justify-center ${
                                    showCustomSpecialty
                                      ? "bg-[#F15D18] border-[#F15D18]"
                                      : "border-gray-300 bg-white"
                                  } ${
                                    editMode
                                      ? "group-hover:border-[#F15D18]"
                                      : ""
                                  }`}
                                >
                                  {showCustomSpecialty && (
                                    <svg
                                      className="w-3 h-3 text-white animate-scale-in"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="3"
                                        d="M5 13l4 4L19 7"
                                      ></path>
                                    </svg>
                                  )}
                                </div>
                              </div>
                              <span className="text-[14px] nunito-semibold text-[#6D7483]">
                                Others (Specify)
                              </span>
                            </label>
                          </div>
                          {/* Custom specialty textarea */}
                          {showCustomSpecialty && editMode && (
                            <div className="mt-4 ml-2 w-[500px]">
                              <div className="flex flex-col">
                                <span className="text-[#1D1D1D] text-[14px] nunito-regular ">
                                  Others (Specify)
                                </span>
                                <div className="flex gap-2 mb-2">
                                  <input
                                    type="text"
                                    value={customSpecialty}
                                    onChange={(e) => {
                                      setCustomSpecialty(e.target.value);
                                      setCustomSpecialtyError("");
                                    }}
                                    disabled={isLoadingSave}
                                    className="flex-1 p-2 border border-[#D7DEDD] rounded-[6px] text-[14px] nunito-regular outline-none"
                                    placeholder="Enter your specialty"
                                    required
                                  />
                                </div>
                                {customSpecialtyError && (
                                  <span className="text-red-500 text-[13px]">
                                    {customSpecialtyError}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className=" w-full flex gap-[320px]">
                          <div>
                            <label className="text-[20px] text-[#696969] nunito-semibold">
                              {" "}
                              Rate per minute (USD)
                            </label>
                            <input
                              type="number"
                              name="ratePerMinute"
                              placeholder={
                                !formData?.ratePerMinute &&
                                "Set what you charge per minute"
                              }
                              value={formData?.ratePerMinute}
                              onChange={handleChange}
                              className={`mt-1 block px-2 rounded-md   nunito-semibold focus:border-[#F15D18] focus:ring-[#F15D18] border-gray-300 ${
                                editMode
                                  ? "border-[1px] text-[12px]  text-[#696969]  w-52 h-10"
                                  : formData?.ratePerMinute
                                  ? "text-[18px] text-[#696969] bg-transparent disabled:cursor-not-allowed "
                                  : "border-[1px] text-[12px]   text-[#696969] bg-transparent w-52 h-10"
                              }`}
                              disabled={!editMode || isLoadingSave}
                              readOnly={!editMode}
                            />
                          </div>
                          <div className="col-span-2">
                            <label className="text-[20px] text-[#696969] nunito-semibold">
                              {" "}
                              Professional Bio
                            </label>
                            <textarea
                              name="bio"
                              value={formData?.bio || ""}
                              placeholder={
                                !formData?.bio &&
                                "Briefly describe your skills and experience here"
                              }
                              onChange={handleChange}
                              className={`mt-1 block px-2 rounded-md  focus:border-[#F15D18] focus:ring-[#F15D18] border-gray-300 ${
                                editMode
                                  ? "border-[1px] text-[12px]  nunito-regular text-[#696969] w-60"
                                  : formData?.bio
                                  ? "text-[18px] text-[#696969]  nunito-semibold bg-transparent disabled:cursor-not-allowed "
                                  : "border-[1px] text-[12px] nunito-regular  text-[#696969] bg-transparent w-60"
                              }`}
                              rows={3}
                              disabled={!editMode || isLoadingSave}
                              readOnly={!editMode}
                            />
                          </div>
                        </div>

                      
                      </>
                    )}
                  </div>
                )}
              </div>

              {/* Activity History */}
              <div className="bg-white rounded-lg  shadow p-6">
                <div className="flex items-center mb-4">
                  <h2 className="text-[20px] text-[#696969] nunito-semibold">
                    {" "}
                    Activity History
                  </h2>
                </div>
                <div className="space-y-4  max-h-96 overflow-y-auto">
                  {isLoadingActivities ? (
                    // <p className="text-gray-500">Loading activity history...</p>
                    <Loader className="animate-spin text-[#F15D18]" size={24} />
                  ) : activities.length > 0 ? (
                    <>
                      {activities.map((activity: any, index: number) => (
                        <div
                          key={index}
                          className="border-b p-3 pb-4"
                          ref={
                            index === activities.length - 1
                              ? lastActivityRef
                              : null
                          }
                        >
                          <p className="text-[#696969] text-[18px] nunito-semibold capitalize">
                            {activity.type.replace("_", " ")}
                          </p>
                          <p className="flex items-center text-[14px] text-[#919191]">
                            <Clock className="w-[14px] h-[14px]" />
                            {new Date(
                              activity.timestamp.seconds * 1000
                            ).toLocaleString()}
                          </p>
                          <p className="text-[14px] nunito-semibold text-[#919191]">
                            {activity.metadata.details}
                          </p>
                        </div>
                      ))}

                      {!hasMore && activities.length > 0 && (
                        <div className="text-center text-sm text-gray-500 py-2">
                          No more activities to load
                        </div>
                      )}
                    </>
                  ) : (
                    <p className="text-sm text-gray-600">
                      No activity recorded yet.
                    </p>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {/* Profile Information */}
              <div className="bg-white rounded-[8px] shadow p-6 relative">
                {" "}
                <div className="flex justify-between items-center mb-2">
                  <h2 className="text-[20px] text-[#696969] nunito-semibold">
                    {" "}
                    Organization Information
                  </h2>
                  {(user?.teamRole === "customer_owner" ||
                    user?.teamRole === "expert_owner") && (
                    <button
                      className="text-[#696969] hover:text-gray-600"
                      onClick={() => setEditingOrg(!editingOrg)}
                    >
                      <img
                        src={EditIcon}
                        alt="No Data"
                        className="h-[32px] w-[32px]"
                      />
                    </button>
                  )}
                </div>
                {!editingOrg ? (
                  <div className="flex mt-6">
                    <div className="mr-4">
                      <div className=" p-2 w-16 h-16 flex items-center justify-center">
                        <Building2 className="w-[80px] h-[80px] stroke-[0.5px]" />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="flex justify-between">
                        <div>
                          <p className=" flex gap-1 nunito-semibold text-[18px] text-[#696969]">
                            Organization Name:{" "}
                            <span className="nunito-semibold">
                              {orgFormData.organizationName || "N/A"}
                            </span>
                          </p>
                          <p className=" flex gap-1 nunito-semibold text-[18px] text-[#696969]">
                            Website:
                            <span className="nunito-semibold">
                              {orgFormData.organizationURL || "N/A"}
                            </span>
                          </p>
                          <p className=" flex gap-1 nunito-semibold text-[18px] text-[#696969]">
                            Address:{" "}
                            <span className="nunito-semibold">
                              {orgFormData.addressLine1},{orgFormData.city},
                              {getStateFullName(
                                orgFormData.country,
                                orgFormData.state
                              )}
                              ,{getCountryFullName(orgFormData.country)},{" "}
                              {orgFormData.zipCode}
                            </span>
                          </p>
                        </div>
                        <div className="flex items-start">
                          <div className="flex items-center gap-1 text-[#696969] ">
                            <NotepadText className="w-[16px] h-[16px] stroke-[0.5px]" />
                            <span className="text-[18px] nunito-semibold">
                              Tax ID: {orgFormData.taxID || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="   ">
                    <form onSubmit={handleOrgSubmit}>
                      {/* Display error message if there's an error */}
                      {orgUpdateError && (
                        <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md flex items-center">
                          <AlertCircle className="h-5 w-5 mr-2" />
                          <span>{orgUpdateError}</span>
                        </div>
                      )}
                      <div className="mb-4">
                        <label
                          htmlFor="organizationName"
                          className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                        >
                          Organization Name
                        </label>
                        <input
                          type="text"
                          id="organizationName"
                          name="organizationName"
                          placeholder="Enter Name"
                          className="w-[49%] h-[46px] px-3 py-2 nunito-normal text-[#404040] text-[14px] border-[#D7DEDD] border-[1px] rounded-[6px]  outline-none transition"
                          value={orgFormData.organizationName}
                          onChange={handleOrgChange}
                          required
                          disabled={isUpdatingOrg}
                        />
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label
                            htmlFor="organizationURL"
                            className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                          >
                            Organization URL
                          </label>
                          <input
                            type="text"
                            id="organizationURL"
                            name="organizationURL"
                            placeholder="Enter URL"
                            className="w-full h-[46px] px-3 py-2 nunito-normal text-[#404040] text-[14px] border-[#D7DEDD] border-[1px] rounded-[6px]  outline-none transition"
                            value={orgFormData.organizationURL}
                            onChange={handleOrgChange}
                            disabled={isUpdatingOrg}
                          />
                        </div>{" "}
                        <div>
                          <label
                            htmlFor="taxID"
                            className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                          >
                            Tax ID (Used for Invoicing)
                          </label>
                          <input
                            type="text"
                            id="taxID"
                            name="taxID"
                            placeholder="Enter Tax ID"
                            className="w-full h-[46px] px-3 py-2 nunito-normal text-[#404040] text-[14px] border-[#D7DEDD] border-[1px] rounded-[6px]  outline-none transition"
                            value={orgFormData.taxID}
                            disabled={isUpdatingOrg}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\s/g, ""); // Remove all spaces
                              handleOrgChange({
                                ...e,
                                target: { ...e.target, name: "taxID", value },
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="mb-4">
                        <label
                          htmlFor="addressLine1"
                          className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                        >
                          Address Line 1
                        </label>
                        <input
                          type="text"
                          id="addressLine1"
                          name="addressLine1"
                          placeholder="Enter Address"
                          className="w-full h-[46px] px-3 py-2 nunito-normal text-[#404040] text-[14px] border-[#D7DEDD] border-[1px] rounded-[6px]  outline-none transition"
                          value={orgFormData.addressLine1}
                          onChange={handleOrgChange}
                          disabled={isUpdatingOrg}
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          htmlFor="addressLine2"
                          className="block  text-[#696969] text-[18px] nunito-semibold mb-1"
                        >
                          Address Line 2
                        </label>
                        <input
                          type="text"
                          id="addressLine2"
                          name="addressLine2"
                          placeholder="Enter Address"
                          className="w-full h-[46px] px-3 py-2 nunito-normal text-[#404040] text-[14px] border-[#D7DEDD] border-[1px] rounded-[6px]  outline-none transition"
                          value={orgFormData.addressLine2}
                          onChange={handleOrgChange}
                          disabled={isUpdatingOrg}
                        />
                      </div>{" "}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label
                            htmlFor="country"
                            className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                          >
                            Country
                          </label>
                          <div className="relative">
                            <select
                              name="country"
                              value={orgFormData.country}
                              onChange={handleOrgChange}
                              disabled={isUpdatingOrg}
                              className="w-full h-[46px] px-3 py-2 border-[#D7DEDD] border-[1px] rounded-[6px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                            >
                              <option value="">Select country</option>
                              {Array.isArray(countries) &&
                                countries.map((country) => (
                                  <option
                                    key={country.shortName || country.code}
                                    value={country.shortName || country.code}
                                  >
                                    {country.name}
                                  </option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-[16px] h-[16px] text-[#696969]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="state"
                            className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                          >
                            State
                          </label>
                          <div className="relative">
                            <select
                              name="state"
                              value={getStateFullName(
                                orgFormData.country,
                                orgFormData.state
                              )}
                              onChange={handleOrgChange}
                              disabled={
                                !orgFormData.country ||
                                !Array.isArray(states) ||
                                states.length === 0 ||
                                isUpdatingOrg
                              }
                              className="w-full h-[46px] px-3 py-2 border-[#D7DEDD] border-[1px] rounded-[6px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                            >
                              <option value="">
                                {!orgFormData.country
                                  ? "Select country first"
                                  : "Select state"}
                              </option>
                              {Array.isArray(states) &&
                                states.map((state, index) => (
                                  <option key={index} value={state}>
                                    {state}
                                  </option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-[16px] h-[16px] text-[#696969]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                        <div>
                          <label
                            htmlFor="city"
                            className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                          >
                            City
                          </label>
                          <input
                            type="text"
                            id="city"
                            name="city"
                            placeholder="Enter City"
                            value={orgFormData.city}
                            onChange={handleOrgChange}
                            disabled={isUpdatingOrg}
                            className="w-full h-[46px] px-3 py-2 border-[#D7DEDD] border-[1px] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="zipCode"
                            className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                          >
                            Zip Code
                          </label>
                          <input
                            type="text"
                            id="zipCode"
                            name="zipCode"
                            placeholder="Enter Zip code"
                            className="w-full h-[46px] px-3 py-2 border-[#D7DEDD] border-[1px] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                            value={orgFormData.zipCode}
                            onChange={handleOrgChange}
                            disabled={isUpdatingOrg}
                          />
                        </div>
                      </div>
                      <div className="flex gap-4 mt-4">
                        <button
                          type="submit"
                          disabled={isUpdatingOrg}
                          className="w-[120px] h-[40px] px-6 py-2 text-[16px] bg-[#F15D18] text-white nunito-semibold rounded-[8px] hover:bg-orange-600 disabled:bg-gray-400 disabled:cursor-not-allowed flex justify-center items-center"
                        >
                          {isUpdatingOrg ? (
                            <Loader className="animate-spin h-5 w-5" />
                          ) : (
                            "Save"
                          )}
                        </button>
                        <button
                          type="button"
                          className="w-[120px] h-[40px] px-6 py-2 border border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                          onClick={() => {
                            setEditingOrg(false);
                            // Reset orgFormData to latest orgData from Redux
                            if (orgData) {
                              setOrgFormData({
                                organizationName: orgData.name || "",
                                organizationURL: orgData.url || "",
                                taxID: orgData.taxId || "",
                                addressLine1:
                                  orgData.billingAddress?.address_1 || "",
                                addressLine2:
                                  orgData.billingAddress?.address_2 || "",
                                country: orgData.billingAddress?.country || "",
                                state: orgData.billingAddress?.state || "",
                                city: orgData.billingAddress?.city || "",
                                zipCode: orgData.billingAddress?.postcode || "",
                              });
                            }
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
              {/* team information */}
              {currentTeam !== null && (
                <div className=" rounded-[8px] shadow p-6  bg-white">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-[20px] text-[#696969] nunito-semibold">
                      {" "}
                      Team Information
                    </h2>
                    {(user?.teamRole === "customer_owner" ||
                      user?.teamRole === "expert_owner") && (
                      <button
                        onClick={() => setEditing(!editing)}
                        className="p-2 text-[#696969] hover:text-gray-700 "
                      >
                        <img src={EditIcon} className="w-[32px] h-[32px]" />
                      </button>
                    )}
                  </div>

                  {!editing ? (
                    <div className="space-y-6">
                      <div className="space-y-1">
                        <label className="block text-[#696969] text-[18px] nunito-semibold">
                          Team Name
                        </label>
                        <p className="text-[#696969] text-[18px] nunito-semibold">
                          {orgData?.teamName}
                        </p>
                        <div className="  border-b "></div>
                      </div>

                      <div className=" border-gray-200 pt-4 space-y-1">
                        <label className="block text-[#696969] text-[18px] nunito-semibold">
                          Role
                        </label>
                        <p className="text-[#696969] text-[18px] nunito-semibold">
                          {teamRole === "customer_team_lead" ||
                          teamRole === "expert_team_lead"
                            ? "Team Lead"
                            : teamRole === "customer_team_member" ||
                              teamRole === "expert_team_member"
                            ? "Team Member"
                            : "Team Owner"}{" "}
                        </p>
                        <div className="  border-b"></div>
                        {(user?.teamRole === "customer_team_lead" ||
                          user?.teamRole === "customer_owner" ||
                          user?.teamRole === "expert_team_lead" ||
                          user?.teamRole === "expert_owner") && (
                          <button
                            onClick={handleViewTeamDetails}
                            className="flex pt-3 text-[18px] text-[#F15D18] nunito-semibold underline"
                          >
                            View Team Details
                          </button>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="">
                      <form onSubmit={handleTeamFormSubmit}>
                        <div className="mb-4">
                          <label
                            htmlFor="teamName"
                            className="block text-[#696969] text-[18px] nunito-semibold mb-1"
                          >
                            Team Name
                          </label>
                          <input
                            type="text"
                            id="teamName"
                            name="teamName"
                            value={teamFormData.teamName}
                            onChange={handleTeamFormChange}
                            disabled={isUpdatingTeam}
                            className="w-[50%] p-2 border-[1px] nunito-medium text-[#696969] text-[18px] nunito-semibold border-[#D7DEDD] rounded-[6px]   outline-none transition"
                          />
                        </div>{" "}
                        <div className="flex gap-4">
                          <button
                            type="submit"
                            className="w-[120px] flex justify-center h-[40px] px-6 py-2 bg-[#F15D18] text-white rounded-[8px] hover:bg-orange-600 transition focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
                          >
                            {isUpdatingTeam ? (
                              <Loader className="animate-spin h-5 w-5" />
                            ) : (
                              "Save"
                            )}
                          </button>
                          <button
                            type="button"
                            className="w-[120px] h-[40px] px-6 py-2 border border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                            onClick={() => {
                              setEditing(false);
                              setTeamFormData((prev) => ({
                                ...prev,
                                teamName: currentTeam?.teamName || "",
                              }));
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>

        {changePassConfirm && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="fixed inset-0 bg-black bg-opacity-50"></div>
            <div className="bg-white  w-[549px] rounded-lg shadow-[16px]  p-4 z-10">
              <div className="flex justify-end">
                <button
                  className="text-gray-500 flex justify-end hover:text-gray-700"
                  onClick={() => setChangePassConfirm(false)}
                  disabled={changePassLoading}
                >
                  <X className="w-[32px] h-[32px]" />
                </button>
              </div>
              <div className="flex justify-center items-center">
                <p className="text-[24px] nunito-semibold text-[#0A0A0A]">
                  Are you sure you want to change password ?
                </p>
              </div>
              <div className="flex justify-center mt-7 space-x-4">
                <button
                  className="py-3 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                  onClick={() => setChangePassConfirm(false)}
                  disabled={changePassLoading}
                >
                  No
                </button>
                <button
                  className="py-3 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600 flex justify-center items-center"
                  onClick={async () => {
                    setChangePassLoading(true);
                    await handleChangePassword();
                    setChangePassLoading(false);
                    setChangePassConfirm(false);
                  }}
                  disabled={changePassLoading}
                >
                  {changePassLoading ? (
                    <Loader className="animate-spin text-white" size={24} />
                  ) : (
                    "Yes"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        {passwordChangeModel && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
    <div className="bg-white rounded-[16px]  p-10 w-[480px] relative">
     
      <h1 className="text-[24px] nunito-semibold text-center text-[#0A0A0A] mb-3">
        Change Password
      </h1>
      <p className="text-[#404040] text-[16px] nunito-semibold text-center mb-6">
        Please fill the below details to change your password
      </p>
      <div className="flex justify-center">
  <div className="space-y-6 px-6 ">
    {/* Current Password Field */}
    <div>
      <label className="block text-[#404040] text-[16px] nunito-semibold mb-3">
        Enter Current Password
      </label>
      <div className="relative w-[320px] ">
        <input
          id="currentPassword"
          type={showCurrentPassword ? "text" : "password"}
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          disabled={isLoadingPassword}
          placeholder="Enter current password"
          className="w-full px-4 py-3 border-2 border-[#696969] rounded-[6px] text-[16px] placeholder-[#404040] focus:outline-none focus:border-orange-500 transition-colors"
        />
        <button
          type="button"
          onClick={() => setShowCurrentPassword(!showCurrentPassword)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
          tabIndex={-1}
        >
          {showCurrentPassword ? (
            <Eye className="h-[24px] text-[#696969] w-[24px]" />
          ) : (
            <EyeOff className="h-[24px] text-[#696969] w-[24px]" />
          )}
        </button>
      </div>
      {errorMessage && (
        <p className="text-[#FD7542] text-[10px] mt-2">{errorMessage}</p>
      )}
    </div>
    {/* New Password Field */}
    <div>
      <label className="block text-[#404040] text-[16px] nunito-semibold mb-3">
        Enter New Password 
      </label>
      <div className="relative w-[320px] ">
        <input
          id="newPassword"
          type={showNewPassword ? "text" : "password"}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          disabled={isLoadingPassword}
          placeholder="Enter new password"
          className="w-full px-4 py-3 border-2 border-[#696969] rounded-[6px] text-[16px] placeholder-[#404040] focus:outline-none focus:border-orange-500 transition-colors"
        />
        <button
          type="button"
          onClick={() => setShowNewPassword(!showNewPassword)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
          tabIndex={-1}
        >
          {showNewPassword ? (
            <Eye className="h-[24px] text-[#696969] w-[24px]" />
          ) : (
            <EyeOff className="h-[24px] text-[#696969] w-[24px]" />
          )}
        </button>
      </div>
      <p className="text-[#A8A8A8] text-[16px] nunito-semibold mt-3 leading-relaxed">
        Password must be minimum 8 characters,<br/>
        with uppercase, lowercase, a number (0-9),<br/>
        and a special character (!, @, #, $, %, ^, &, *)
      </p>  
    </div>
   
  </div>
</div>
      {/* Buttons */}

              {/* Action Buttons */}
              <div className="flex justify-center">
          <div className="flex gap-2 mt-6 px-6">
              <button
              className=" flex justify-center items-center w-[190px]  h-[48px] bg-[#F15D18] text-[16px] nunito-semibold text-white rounded-[8px]"
            onClick={handleConfirm}
            disabled={isLoadingPassword}
            >
               {isLoadingPassword ? (
            <Loader className="animate-spin text-white" size={24} />
          ) : (
            "Confirm New Password"
          )}
            </button>
            <button
              className="p-3 w-[120px] h-[48px] border border-[#F15D18] text-[#F15D18] text-[16px] nunito-medium rounded-[8px]"
                onClick={handleCancel}
                 disabled={isLoadingPassword}
            >
              Cancel
            </button>{" "}
          
          </div>
      </div>
      </div>
    </div>
  // </div>
)}
  {passwordChangeSuccessModel && (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg w-[450px]  p-6 relative text-center shadow-lg">
                  {/* Close Button */}
                  <button
                    onClick={() => setPasswordChangeSuccessModel(false)}
                    className="absolute top-3 right-3 text-[#696969] hover:text-gray-700"
                  >
                    <X className="w-[32px] h-[32px]" />
                  </button>

                  {/* Check Icon */}
                  <div className="flex justify-center mt-1">
                    <div className="bg-[#4BB847] border-gray-100 w-[126px] h-[126px] border-[10px] rounded-full p-4 flex items-center justify-center">
                      <Check className="text-white w-[80px] h-[80px]" />
                    </div>
                  </div>
                  <div className="">
                 

                    {/* Success Message */}
                    <p className="text-[#424242] text-[24px] mt-1 nunito-semibold">
          Password successfully updated!
                    </p>
                  </div>
                </div>
              </div>
            )}
      </div>
    </Layout>
  );
}
